export const CONTRACTOR_SUPERVISION_BASE = "/SLN/Contractor/supervision";

/**
 * Workspace نظارت پیمانکار — آینه پنل ناظر، فقط روی Area=Contractor.
 * Labels: داشبورد / پروژه‌های جاری / پروژه‌های قبلی
 */
export const CONTRACTOR_SUPERVISION_NAV_ITEMS = [
  {
    id: "dashboard",
    labelFa: "داشبورد",
    path: CONTRACTOR_SUPERVISION_BASE,
    matchPaths: [CONTRACTOR_SUPERVISION_BASE],
  },
  {
    id: "projects",
    labelFa: "پروژه‌های جاری",
    path: "/SLN/Contractor/ProjectAssignments",
    matchPaths: ["/SLN/Contractor/ProjectAssignments"],
  },
  {
    id: "closedProjects",
    labelFa: "پروژه‌های قبلی",
    path: "/SLN/Contractor/ProjectAssignments/Closed",
    matchPaths: ["/SLN/Contractor/ProjectAssignments/Closed"],
  },
];

const normalizePath = (pathname) =>
  (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";

const pathMatches = (pathname, candidates) => {
  const path = normalizePath(pathname);
  return (candidates || []).some((p) => {
    const n = normalizePath(p);
    return path === n || path.startsWith(`${n}/`);
  });
};

export const isContractorSupervisionNavSelected = (item, pathname) => {
  const path = normalizePath(pathname);
  const candidates = (item.matchPaths || [item.path]).map(normalizePath);

  if (item.id === "dashboard") {
    return candidates.some((p) => path === p);
  }

  if (item.id === "projects") {
    const closedItem = CONTRACTOR_SUPERVISION_NAV_ITEMS.find(
      (x) => x.id === "closedProjects"
    );
    if (pathMatches(pathname, closedItem?.matchPaths)) {
      return false;
    }
  }

  return candidates.some((p) => path === p || path.startsWith(`${p}/`));
};

/** @deprecated kept for any leftover imports — use CONTRACTOR_SUPERVISION_NAV_ITEMS */
export const CONTRACTOR_SUPERVISION_TOOLS = CONTRACTOR_SUPERVISION_NAV_ITEMS.map(
  (item) => ({
    id: item.id,
    labelFa: item.labelFa,
    description: item.labelFa,
    path: item.path,
  })
);
